
import { Component, Vue, Prop } from "vue-property-decorator";
import { SelectType } from "./pFormSelect.types";
import PDropDownContainer from "../PDropDownContainer/PDropDownContainer.vue";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import { PFormSelectTranslations, translations } from "./pFormSelectLanguages";

@Component({
  components: {
    PDropDownContainer,
    PIcon,
  },
})
export class PFormSelectMulti extends Vue {
  @Prop({ required: true }) value!: string[];
  @Prop({ required: true }) options!: SelectType[];
  @Prop({ required: false, default: "" }) placeholder!: string;
  @Prop({ required: false, default: "es" }) language!: string;
  @Prop({ required: false }) translation!: PFormSelectTranslations;
  @Prop({ required: false, default: "" }) icon!: string;
  @Prop({ required: false, default: "" }) iType!: string;
  @Prop({ required: false, default: 16 }) iSize!: number;
  @Prop({ required: false, default: "#6f6f6f" }) iColor!: string;

  valueTemp: string[] = [];
  pussOption = false;
  translator: PFormSelectTranslations = translations[0].translations;

  created(): void {
    const language = this.language.split("-").shift();
    const translation = translations.find((tran) => tran.language === language)?.translations;
    if (translation) {
      this.translator = translation;
    }
    if (this.translation) {
      this.translator = Object.assign({}, this.translator, this.translation);
    }
  }
  mounted(): void {
    this.fillValueTempInitial();
  }

  get selectedTexts(): string[] {
    if (this.valueTemp.length > 0) {
      return this.valueTemp;
    } else {
      return [];
    }
  }
  get localPlaceHolder(): string {
    return !this.placeholder && this.translator?.textSelectAnOption
      ? this.translator?.textSelectAnOption
      : this.placeholder;
  }

  giveMeTextOption(slectedText: string): string {
    const s = (slectedText ?? "").toString().trim();
    const optionSelected = this.options.find((op) => (op.value ?? "").toString().trim() === s);
    if (optionSelected) {
      return optionSelected.text;
    }
    return s;
  }
  fillValueTempInitial(): void {
    this.$nextTick(() => {});
    this.options.forEach((op, index) => {
      const ov = (op.value ?? "").toString().trim();
      if (this.value.some((val) => (val ?? "").toString().trim() === ov)) {
        this.$set(this.valueTemp, index, ov);
      }
    });
  }
  selectItem(itemValue: any): void {
    const v = (itemValue ?? "").toString().trim();
    if (!this.valueTemp.find((vt) => (vt ?? "").toString().trim() === v)) {
      this.valueTemp.push(v);
    }
    const out = this.valueTemp.map((x) => (x ?? "").toString().trim());
    this.$emit("input", out);
    this.$emit("change", out);
    this.pussOption = false;
  }
  unSelectedItem(itemValue: any): void {
    const v = (itemValue ?? "").toString().trim();
    const idx = this.valueTemp.findIndex((x) => (x ?? "").toString().trim() === v);
    if (idx > -1) this.valueTemp.splice(idx, 1);
    const out = this.valueTemp.map((x) => (x ?? "").toString().trim());
    this.$emit("input", out);
    this.$emit("change", out);
  }
  giveMeClass(itemValue: any): string {
    const v = (itemValue ?? "").toString().trim();
    if (this.valueTemp.find((vt) => (vt ?? "").toString().trim() === v)) {
      return "itemSelectSelected_PFormSelectMulti";
    } else {
      return "itemSelect_PFormSelectMulti";
    }
  }
}
export default PFormSelectMulti;
